import React from 'react';
import { Fragment, useState } from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Badge from '@mui/material/Badge';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import RuleFolderIcon from '@mui/icons-material/RuleFolder';
import BuildIcon from '@mui/icons-material/Build';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import LinkIcon from '@mui/icons-material/Link';
import List from '@mui/material/List';
import Collapse from '@mui/material/Collapse';
import { Link } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

export const MainListItems = () => {
  const { pendingProductsCount } = useAuth();
  const [openUtilities, setOpenUtilities] = useState(false);

  const handleUtilitiesClick = () => {
    setOpenUtilities(!openUtilities);
  };

  return (
    <Fragment>
      <ListItemButton component={Link} to={'/dashboard'}>
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary="Dashboard" />
      </ListItemButton>
      <ListItemButton component={Link} to={'/accounts'}>
        <ListItemIcon>
          <PeopleIcon />
        </ListItemIcon>
        <ListItemText primary="Accounts" />
      </ListItemButton>
      <ListItemButton component={Link} to={'/pendingProducts'}>
        <ListItemIcon>
          <RuleFolderIcon />
        </ListItemIcon>
        <ListItemText primary="Pending products" />
        <Badge badgeContent={pendingProductsCount} color="error" showZero sx={{ mr: 1 }} />
      </ListItemButton>
      <ListItemButton onClick={handleUtilitiesClick}>
        <ListItemIcon>
          <BuildIcon />
        </ListItemIcon>
        <ListItemText primary="Utilities" />
        {openUtilities ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={openUtilities} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton component={Link} to="/utilities/stripeBalance" sx={{ pl: 4 }}>
            <ListItemIcon>
              <CurrencyExchangeIcon />
            </ListItemIcon>
            <ListItemText primary="Balance & Exchange" />
          </ListItemButton>
          <ListItemButton component={Link} to="/utilities/utms" sx={{ pl: 4 }}>
            <ListItemIcon>
              <LinkIcon />
            </ListItemIcon>
            <ListItemText primary="UTMs" />
          </ListItemButton>
        </List>
      </Collapse>
      <ListItemButton component={Link} to={'/plans'}>
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <ListItemText primary="Plans" />
      </ListItemButton>
    </Fragment>
  );
};
